<template>
  <div v-if="visible" class="app-loading">
    <div class="app-loading__overlay" :style="overlayStyle"></div>
    <div class="app-loading__spinner">
      <app-loading-icon :color="spinnerStyle.color" />
      <p v-if="message" class="app-loading__spinner-message">{{ message }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { toggleOverflowBody } from 'common/functions.js'
import AppLoadingIcon from 'components/AppLoadingIcon.vue'
import { getConfig } from '@/configs/index.js'

const config = getConfig()

const visible = ref(false)
const message = ref('')
const overlayStyle = ref({})
const spinnerStyle = ref({})

function show(options = {}) {
  message.value = options.message || ''
  overlayStyle.value = {
    background: options.backgroundColor || config.loader.bgColor,
  }
  spinnerStyle.value = {
    color: options.spinnerColor ? options.spinnerColor : config.loader.color,
  }
  visible.value = true
  toggleOverflowBody(true)
}

function hide() {
  visible.value = false
  toggleOverflowBody(false)
}

defineExpose({ show, hide })
</script>

<style lang="scss">
.app-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1051;

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  &__spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 4px;
    padding: 18px;
    max-width: 450px;
    color: #fff;

    &-message {
      margin: 40px 20px 0;
      text-align: center;
      font-size: 14px;
    }
  }
}
</style>
